import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "@phosphor-icons/react";
import { api, formatApiErrorDetail } from "../../lib/api";
import { toast } from "sonner";

export function UpgradePanel() {
    const [email, setEmail] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [done, setDone] = useState(false);

    async function upgrade(e) {
        e.preventDefault();
        setSubmitting(true);
        try {
            await api.post("/orders/upgrade", { email, new_plan: "bundle" });
            setDone(true);
            toast.success("Your reservation is upgraded to the full bundle.");
        } catch (err) {
            toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Could not upgrade.");
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7 }}
            className="mt-10 max-w-2xl mx-auto rounded-3xl bg-[#F4F6FB] p-7 border border-[#E5E1D8]/70"
            data-testid="upgrade-panel"
        >
            <p className="font-sans text-xs uppercase tracking-[0.22em] text-[#6B7DB8] font-semibold mb-2">
                Already reserved the software?
            </p>
            <h3 className="font-serif text-xl text-[#2D2B2A] mb-1">
                Upgrade to a tablet edition — anytime.
            </h3>
            <p className="text-sm text-[#5C5A59] mb-5 leading-relaxed">
                Change your mind? Tell us your email and we'll move your reservation to the 15″ or 17″ tablet + headphones bundle. No money is taken until launch.
            </p>
            {done ? (
                <p className="text-sm text-[#4A5A95] font-medium" data-testid="upgrade-done">
                    🌸 Your reservation is now the full bundle. We'll write to you before we ship.
                </p>
            ) : (
                <form onSubmit={upgrade} className="flex flex-col sm:flex-row gap-2" data-testid="upgrade-form">
                    <input
                        type="email" required value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="The email you reserved with"
                        className="flex-1 px-5 py-3 rounded-full text-sm bg-white text-[#2D2B2A] placeholder-[#8A8786] border border-[#E5E1D8] focus:border-[#8C9ECB] outline-none"
                        data-testid="upgrade-email"
                    />
                    <button
                        type="submit" disabled={submitting}
                        className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full bg-[#6B7DB8] hover:bg-[#4A5A95] text-white font-medium text-sm transition-all disabled:opacity-60"
                        data-testid="upgrade-submit"
                    >
                        {submitting ? "Saving…" : "Upgrade my reservation"}
                        <ArrowRight size={14} weight="bold" />
                    </button>
                </form>
            )}
        </motion.div>
    );
}
